import ja from './ja'
import Utils from '../Utils'

var jaMsg = {
  'agreements.title': '契約',
  'agreements.error.mandatory': "Deeper サービスを引き続きご利用になるには、同意が必要です",
  'agreements.error.blank': "選択する",
  'agreements.back': '戻る',
  'agreements.agree': '同意する',
  'agreements.decline': '同意しない',
  'agreements.text.full': '完全合意'
}

Utils.addTerms(jaMsg, ja)

export default jaMsg



// WEBPACK FOOTER //
// ./src/lang/jaMsg.js